
























































































































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import {
 AdminPendingTx
} from "@/admin/types";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import Button from "@/shared/components/ui/Button.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import { usePendingTxStore } from "@/admin/store/pendingTx";

@Component({
  components: {
    Button,
    Input,
    ErrorSummary
  }
})
export default class AdminUtilityPendingTx extends Vue {
  $validator: Validator;

  pendingTxStore = usePendingTxStore();

  accountNumber = "";
  emailAddress = "";
  firstName = "";
  lastName = "";

  get canDelete (): boolean { return this.pendingTxStore.canSearch; }

  get accountSearchEnabled (): boolean {
    if (!this.accountNumber) {
      return false;
    }

    if (!this.pendingTxStore.canSearch) {
      return false;
    }

    const accountNumber = this.accountNumber.trim();
    if (!accountNumber || accountNumber.length === 0) {
      return false;
    }

    return true;
  }

  get emailSearchEnabled (): boolean {
    if (!this.emailAddress) {
      return false;
    }

    if (!this.pendingTxStore.canSearch) {
      return false;
    }

    const emailAddress = this.emailAddress.trim();
    if (!emailAddress || emailAddress.length === 0) {
      return false;
    }

    return true;
  }

  get firstNameSearchEnabled (): boolean {
    if (!this.firstName) {
      return false;
    }

    if (!this.pendingTxStore.canSearch) {
      return false;
    }

    const firstName = this.firstName.trim();
    if (!firstName || firstName.length === 0) {
      return false;
    }

    return true;
  }

  get lastNameSearchEnabled (): boolean {
    if (!this.lastName) {
      return false;
    }

    if (!this.pendingTxStore.canSearch) {
      return false;
    }

    const lastName = this.lastName.trim();
    if (!lastName || lastName.length === 0) {
      return false;
    }

    return true;
  }

  get nameSearchEnabled (): boolean { return this.firstNameSearchEnabled && this.lastNameSearchEnabled; }

  submitDeleteRequest (tx: AdminPendingTx) {
    this.pendingTxStore.delete(tx);
  }

  onSubmitAccountNumber (): void {
    this.pendingTxStore.search({
          accountNumber: this.accountNumber,
          emailAddress: null,
          firstName: null,
          lastName: null
        });
  }

  onSubmitEmailAddress (): void {
    this.pendingTxStore.search({
          accountNumber: null,
          emailAddress: this.emailAddress,
          firstName: null,
          lastName: null
        });
  }

  onSubmitName (): void {
    this.pendingTxStore.search({
          accountNumber: null,
          emailAddress: null,
          firstName: this.firstName,
          lastName: this.lastName
        });
  }
}
